import TextField from '@mui/material/TextField';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { FieldsetBox, LegendStyled } from '../styling/StyledComponents';
import DateRange from '../selectComponents/DateRange';
import DateFilter from '../selectComponents/DateFilter';
import SmrySelect from '../selectComponents/SmrySelect';

const variableChoices = [
  {value: 'temp',  label: 'Temperature'},
  {value: 'dwpt',  label: 'Dewpoint'},
  {value: 'wetb',  label: 'Wet Bulb Temperature'},
  {value: 'wchill', label: 'Wind Chill'},
  {value: 'htindx', label: 'Heat Index'},
  {value: 'pcpn',  label: 'Precipitation'},
  {value: 'wspd',  label: 'Wind Speed'},
  {value: 'wgust', label: 'Wind Gust'},
  {value: 'rhum',  label: 'Relative Humidity'},
  {value: 'pres',  label: 'Station Pressure'},
  {value: 'slp',   label: 'Sea Level Pressure'},
  {value: 'altp',  label: 'Altimeter Setting'},
  {value: 'srad',  label: 'Solar Radiation'},
]

export default function ConhrlyOptions(props) {
  const { userParams, setUserParams, selectOptions, handleChange, setDisableGoButton } = props;

  return (
    <Stack direction="column" spacing={1} sx={{ mt: 2 }}>
      <DateRange 
        userParams={userParams}
        setUserParams={setUserParams}
      />
      <DateFilter
        userParams={userParams}
        setUserParams={setUserParams}
        selectOptions={selectOptions}
        handleChange={handleChange}
      />
      <FieldsetBox component="fieldset" sx={{ mt: 1 }}>
        <LegendStyled>Threshold definition</LegendStyled>
        <Stack direction="row" spacing={0}>
          <Typography variant="body2" sx={{ m: 1, ml: 0 }}>
            Runs of consecutive hours with:
          </Typography>
          <SmrySelect 
            userParams={userParams}
            setUserParams={setUserParams} 
            selectOptions={selectOptions} 
            handleChange={handleChange} 
            setDisableGoButton={setDisableGoButton} 
            smryChoices={null}
            variableChoices={variableChoices} 
          />
        </Stack>
      </FieldsetBox>
      <Box>
        <TextField
          name="numrec"
          placeholder="enter value"
          label="Number of records"
          value={userParams.numrec}
          onChange={handleChange}
          sx={{ width: '15ch', mt: 1 }}
        />
      </Box>
     </Stack>
  )
}
